import Vue from 'vue';
import VueRouter from 'vue-router';
import AllHatches from '@/views/all-hatches.vue';
import Hatch1 from '@/views/hatch-1.vue';
import Hatch2 from '@/views/hatch-2.vue';
import Hatch3 from '@/views/hatch-3.vue';
import Hatch4 from '@/views/hatch-4.vue';
import Port from '@/views/port.vue';
import Starboard from '@/views/starboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'AllHatches',
    component: AllHatches,
    meta: {
      title: 'All Hatches',
    },
  },
  {
    path: '/port',
    name: 'Port',
    component: Port,
    meta: {
      title: 'Port',
    },
  },
  {
    path: '/starboard',
    name: 'Starboard',
    component: Starboard,
    meta: {
      title: 'Starboard',
    },
  },
  {
    path: '/hatch-1',
    name: 'Hatch 1',
    component: Hatch1,
    meta: {
      title: 'Hatch 1',
    },
  },
  {
    path: '/hatch-2',
    name: 'Hatch 2',
    component: Hatch2,
    meta: {
      title: 'Hatch 2',
    },
  },
  {
    path: '/hatch-3',
    name: 'Hatch 3',
    component: Hatch3,
    meta: {
      title: 'Hatch 3',
    },
  },
  {
    path: '/hatch-4',
    name: 'Hatch 4',
    component: Hatch4,
    meta: {
      title: 'Hatch 4',
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
